export default __webpack_public_path__ + "static/media/confetti-modal.fc60f8a4.png";